import React, { useEffect, useState } from 'react'
import { VariableAccounts } from './VariableAccounts'
import { useSelectorCustom } from '../../../components/general/general-component/abstruct-component/useSelectorCustom'
import { deleteAccount, loadAccounts } from '../../../store/Actions/ActionAccounts'
import { AbstructVar } from '../../../components/general/general-component/abstruct-component/AbstructVar'
import { AbstructLang } from '../../../components/general/general-component/abstruct-component/AbstructLang'
import { DeleteComponent } from '../../../components/general/general-component/abstruct-component/DeleteComponent'
import SectionTopOfTable from '../../../components/general/general-component/section-top-of-table/SectionTopOfTable'
import InnerLoader from '../../../components/general/inner-loader/InnerLoader'
import Warning from '../../../components/general/general-component/warning-delete/Warning'
import EditAccount from './EditAccount'
import FilterAccounts from './FilterAccounts'
import AddAccount from './AddAccount'
import PopUpDetails from './PopUpDetails'
import AddTransaction from '../transactions/AddTransaction'
import AccountCard from '../../../components/cards/AccountCard'
import { PagenationCustom } from '../../../components/general/general-component/abstruct-component/PagenationCustom '
import SinglePagenation from '../../../components/general/pagination/SinglePagenation'
import { UsePermissions, hasPermissions } from '../../../components/general/general-component/abstruct-component/UsePermissions'
import CheckPermissions from '../../../components/general/general-component/check-permissions'
import CheckLazyLoader from '../../../components/general/general-component/check-lazy-loader'

const AllAccounts = () => {
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang()
    const { permissionss, loadingMainPermission } = UsePermissions();
    const accountss = hasPermissions([{ name: "accounts" }], permissionss)
    const { accounts, loadingAccounts } = useSelectorCustom()
    const { state, setOpen, handleEdit, setopenEdit, setOpenDetails } = VariableAccounts()
    const { stateD, warning, setdeletee, setloadDel } = DeleteComponent()
    const [accountsArr, setAccountsArr] = useState([])
    const [isDeleted, setIsDeleted] = useState('')
    const [idDeleted, setIdDeleted] = useState(null)
    const [openTransaction, setOpenTransaction] = useState(false)
    const [account_id, setAccount_id] = useState(null)
    useEffect(() => {
        if (isDeleted && idDeleted) {
            const updatedArr = [...accountsArr];
            const indexToDelete = updatedArr.findIndex(item => item.id === idDeleted);
            if (indexToDelete !== -1) {
                updatedArr.splice(indexToDelete, 1);
                setAccountsArr(updatedArr);
            }
        }
    }, [isDeleted, idDeleted, accountsArr]);
    useEffect(() => {
        if (accounts?.length >= 0) {
            setAccountsArr(accounts)
        }
    }, [accounts]);
    useEffect(() => {
        dispatch(loadAccounts())
    }, []);
    const openAddAccount = e => {
        e.preventDefault()
        setOpen(true)
    }
    const openAddTransaction = (e, id) => {
        e.preventDefault()
        setAccount_id(id)
        setOpenTransaction(true)
    }
    const detailsOfAccount = (id) => {
        console.log(id)
        setAccount_id(id)
        setOpenDetails(true)
    }
    const goToReport = (id) => {
        console.log(id)
        setAccount_id(id)
        navigate(`/accounts/${id}/report`)
    }
    const handleDelete = (id) => {
        dispatch(deleteAccount(id, setloadDel, setIsDeleted, setIdDeleted));
    }
    const { displayArr, pageCount, changePage } = PagenationCustom(accountsArr, 10)
    return (
        <CheckLazyLoader>
            <CheckPermissions array={accountss} loadingMainPermission={loadingMainPermission} >
                <main>
                    <div className="margin_main shadow_main">
                        <FilterAccounts translate={translate} noPadding />
                    </div>
                    <div className="div_table margin_main shadow_main" dir={langLocal == "ar" ? "rtl" : "ltr"} >
                        <SectionTopOfTable langLocal={langLocal} title={translate('accounts')} titleBtn={translate('add_account')} FunctionBtn={openAddAccount} />
                        {
                            loadingAccounts ? <InnerLoader /> :
                                <div className='all-account' >
                                    {
                                        displayArr?.map((account, index) => {
                                            return (
                                                <AccountCard translate={translate} detailsOfAccount={detailsOfAccount}
                                                    openAddTransaction={openAddTransaction} goToReport={goToReport}
                                                    warning={warning} handleEdit={handleEdit} index={index} account={account} langLocal={langLocal} />
                                            )
                                        })
                                    }
                                </div>
                        }
                        <SinglePagenation pageCount={pageCount} changePage={changePage} />
                        <br></br>
                    </div>
                </main>
            </CheckPermissions>

            {
                state.open && (
                    <AddAccount open={state.open} setOpen={setOpen} />
                )
            }
            {
                stateD.deletee == true ? (
                    <Warning loadDel={stateD.loadDel} arr={stateD.arrW} open={stateD.deletee} setOpen={setdeletee} handleDelete={handleDelete} />
                ) : <></>
            }
            {
                state.openEdit && (
                    <EditAccount arr={state.arr1} open={state.openEdit} setOpen={setopenEdit} />
                )
            }
            {
                state.openDetails && (
                    <PopUpDetails account_id={account_id} open={state.openDetails} setOpen={setOpenDetails} />
                )
            }
            {
                openTransaction && (
                    <AddTransaction account_id={account_id} isAccount={false} open={openTransaction} setOpen={setOpenTransaction} />
                )
            }
        </CheckLazyLoader>
    )
}

export default AllAccounts


